import React from 'react';

function ArrowDownSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="10"
      fill="none"
      viewBox="0 0 17 10"
    >
      <path
        fill="#00253E"
        fillRule="evenodd"
        d="M8.5 0a.75.75 0 01.539.228l7.75 8a.75.75 0 01-1.078 1.044L8.5 1.828 1.289 9.272A.75.75 0 01.21 8.228l7.75-8A.75.75 0 018.5 0z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default ArrowDownSvg;
